/**
 * Wraps the image url in a vue style object
 * @param {string} url - The url for the background-image
 * @return {Object} An object that can be used within a vue template's `:style` attribute
 */
export default function bgImageFilter(url) {
    return { 'background-image': `url(${ url })` };
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/filters/bgImage/index.js